import { render, staticRenderFns } from "./WlOfficeVisitInherited.vue?vue&type=template&id=78f7ee60"
import script from "./WlOfficeVisitInherited.vue?vue&type=script&lang=js"
export * from "./WlOfficeVisitInherited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports